import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "__VITE_KEYCLOAK_URL__",
  realm: "__VITE_KEYCLOAK_REALM__",
  clientId: "__VITE_KEYCLOAK_CLIENT_ID__",
});

export default keycloak;
